function initialState() {
  return {
    podcasts: null,

    podcast: {
      subtitle: "",
      image: "",
      keywords: [],
      copyright: "",
      title: "",
      description: "",
      link: "",
      key: "",
      categories: [],
      language: "",
      author: "",
      explicit: false,
      summary: "",
      block: false,
      updated: 0,
      rssFeed: "",
      is_external_feed: false,
      image_key: "",
      pretty_url: null,
      owner_email: "",
      total_size: 0,
      third_party_content: false,
      owner_name: "",
      show_type: "",
      station_key: "",
      station_name: "",
      published: true,
      podcast_type: "", // classic | recording_with_ai
    },

    // the open podcast's country and IP rules from the Access tab, each { action: "allow" | "block", values } or
    // null when its list is empty (an empty list is no rule, whichever action it was saved with); null until loaded
    availability: null,
  }
}

let state = initialState()

export { initialState, state }
